import { useEffect, useState } from 'react';
export function onPushFullScreen(element) {
    if (element == null) {
        return;
    }
    if (isFullScreenMode()) {
        if ('exitFullscreen' in document) {
            document.exitFullscreen()?.then();
        }
        else if ('webkitExitFullscreen' in document) {
            // @ts-ignore
            document.webkitExitFullscreen()?.then();
        }
        else if ('mozExitFullscreen' in document) {
            // @ts-ignore
            document.mozExitFullscreen()?.then();
        }
    }
    else {
        if ('requestFullscreen' in element) {
            element.requestFullscreen()?.then();
        }
        else if ('webkitRequestFullscreen' in element) {
            // @ts-ignore
            element.webkitRequestFullscreen()?.then();
        }
        else if ('mozRequestFullscreen' in element) {
            // @ts-ignore
            element.mozRequestFullScreen()?.then();
        }
    }
}
export function isFullScreenMode() {
    return !!(document.fullscreenElement ||
        // @ts-ignore
        document.webkitFullscreenElement ||
        // @ts-ignore
        document.mozFullscreenElement);
}
export function useIsFullscreen() {
    const [isFS, setFS] = useState(isFullScreenMode());
    useEffect(() => {
        const listener = () => setFS(isFullScreenMode());
        document.addEventListener('fullscreenchange', listener);
        return () => document.removeEventListener('fullscreenchange', listener);
    }, []);
    return isFS;
}
